import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainScreenComponent } from './main-screen/main-screen.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { MainLayoutStore } from './services/main.layout.store';
import { SharedModule } from '../shared/shared.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { TranslatePipe } from '../shared/pipes/translate.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ToastyModule } from '@haithamsboui/ng-toasty';
import { TimeagoCustomFormatter, TimeagoFormatter, TimeagoIntl, TimeagoModule, TimeagoPipe } from 'ngx-timeago';
import { MomentIntl } from '../shared/helpers/MomentIntl';
import { InternationalPhoneNumber2Module } from 'ngx-international-phone-number2';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccordionAnchorDirective, AccordionDirective, AccordionLinkDirective } from './accordion';
import { NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
@NgModule({
  declarations: [
    MainScreenComponent,
    BreadcrumbComponent,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
  ],
  imports: [
    CommonModule,
    LayoutRoutingModule,
    SharedModule,
    ClickOutsideModule,
    BrowserAnimationsModule,
    FormsModule,
    ToastyModule,
    TimeagoModule.forChild({
      intl: { provide: TimeagoIntl, useClass: MomentIntl },
      formatter: { provide: TimeagoFormatter, useClass: TimeagoCustomFormatter },
    }),
    ReactiveFormsModule,
    InternationalPhoneNumber2Module,
    NgSelectModule,
    NgbTypeaheadModule,
    NgbTooltipModule,
    RxReactiveFormsModule,
  ],
  providers: [MainLayoutStore, TranslatePipe, TimeagoPipe],
})
export class LayoutModule {}
